<template xmlns="http://www.w3.org/1999/html">
    <div class="setting-page-content-wrapper features">
        <div class="page-header">
            <div class="title">{{ $t("message.loginlessChat") }}</div>
            <div class="subtitle">{{ $t("settings.visitorLoginFormSubtitles") }}</div>
        </div>
        <section>
            <div class="fields">
                <div>
                    <FeatureItem
                        v-model="customLoginForm"
                        :description="$t('message.vtipyCustomLogin')"
                        :title="$t('message.customLoginFormSettingsTitle')"
                        icon="VisitorFormIcon"
                    />
                    <div class="customLoginForm">
                        <div v-if="customLoginForm">
                            <CustomLoginForm />
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import { defineComponent, ref } from "vue";
import log2 from "../../../../utils/log2";
import * as _ from "lodash";
import { toArray2, toObject2 } from "../../../../utils/languageContent";
import { sendSocketMessage } from "../../../../utils/socketStream";
import CustomLoginForm from "../../../../components/CustomLoginForm.vue";
import FeatureItem from "../components/FeatureItem.vue";

const log = log2("Settings/VisitorLoginForm");
export default {
    name: "VisitorLoginForm",
    components: {
        CustomLoginForm,
        FeatureItem,
    },
    props: {
        updateSettings: {
            type: Function,
            required: true,
        },
    },
    computed: {
        ...mapState({
            settings: (state) => state.setting.settings,
            site: (state) => state.site.site,
            languages: (state) => state.language.languages,
            settingInitialized: (state) => state.setting.initialized,
            visitorScreenUrl: (state) => {
                const isProduction = process.env.ENVIRONMENT === "production";
                const isStage = process.env.ENVIRONMENT === "stage";
                let siteAlias = (state.site.site.customerClientAddress || "").replace(".visitor.supsis.live", "");
                const protocol = isProduction || isStage ? "https" : "http";
                if (siteAlias === "visitor.supsis.live") siteAlias = "demo-site.supsis.live?customer=supsis";
                else siteAlias = "demo-site.supsis.live?customer=" + siteAlias;
                const hostname = isProduction
                    ? siteAlias
                    : isStage
                    ? `demo-site.supsis.live?url=${protocol}://${
                          state.site.site.customerClientAddress || "betavisitor.supsis.live"
                      }/static/js/loader.js`
                    : "localsite.supsis.live?customer=local";
                return `${protocol}://${hostname}`;
            },
            systemLanguages: (state) => state.setting.settings.systemLanguages,
        }),
        customLoginForm: {
            get() {
                return this.settings.customLoginFormEnabled;
            },
            set(value) {
                this.setValue("customLoginFormEnabled", value);
                this.setValue("loginFormRequired", value);
            },
        },
    },
    methods: {
        setValue(key, value) {
            this.updateSettings(key, value);
        },
    },
    mounted() {},
    updated() {
        // log("updated");
        if (this.$validator.locale !== this.$i18n.locale) {
            this.$validator.localize(this.$i18n.locale);
            if (this.submitClicked) this.$validator.validateAll();
            this.$forceUpdate();
        }
    },
    watch: {},
};
</script>

<style scoped lang="scss">
.feature {
    display: flex;
    justify-content: space-between;
    width: 100%;
    padding: 10px;
    border: 1px solid var(--color-border-default);
    border-radius: 4px;
    background: var(--color-bg-neutral-default);
    max-width: 900px;

    .left {
        display: flex;
        align-items: center;
        gap: 20px;

        .icon {
            svg {
                width: 40px;
                height: 40px;
                fill: var(--color-bg-primary-default);
            }
        }

        .feature-title {
            font-size: 16px;
            font-weight: 500;
            color: var(--color-text-strong-default);
        }

        .feature-description {
            font-size: 14px;
            font-weight: 400;
            color: var(--color-text-low-default);
        }
    }
}

.dark-mode .feature {
    background: #1e1e2d;

    .left {
        display: flex;
        align-items: center;
        gap: 20px;

        .icon {
            svg {
                width: 40px;
                height: 40px;
                fill: var(--color-bg-primary-default);
            }
        }

        .feature-title {
            font-size: 16px;
            font-weight: 500;
            color: #fff;
        }

        .feature-description {
            font-size: 14px;
            font-weight: 400;
            color: var(--color-text-low-default);
        }
    }
}

.errSpan {
    font-size: 8px;
    color: var(--color-bg-critical-default);
}

.customLoginForm {
    width: 60%;
    margin: 0px;
    margin-top: 20px;
}

.right {
    display: flex !important;
    align-items: center !important;

    .ant-switch-checked {
        background-color: var(--color-bg-primary-default);
    }
}
</style>
